export default __webpack_public_path__ + "static/pawel_apanasewicz-codeme-5e7c1137dbe49da5c03a3daceef92e43.png";